import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import { useI18n } from 'next-localization';
import useHelpers from 'hooks/helpers';
import { useFetchDerivativeTabDataQuery } from '@/store/fundDetails/services/fundDetailsApi';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import FundDetailsTabList from '../components/FundDetailsList';

const FundDetailsDerivativeTab = () => {
  const { t } = useI18n();
  const { getErrorDictionary } = useHelpers();
  const { shareClass, language, countryCode, correlationFundRangeId, site } = usePayload();
  const { data, error, isLoading } = useFetchDerivativeTabDataQuery(
    {
      shareClass,
      language,
      countryCode,
      correlationFundRangeId,
      site,
    },
    {
      skip: !shareClass,
    }
  );
  return (
    <FundDetailsTabRow className="mt-4">
      {isLoading ? (
        <FundDetailsTabSkeleton />
      ) : error ? (
        <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
      ) : data && data.content.derivativeUsage.length !== 0 ? (
        <FundDetailsTabList data={data.content.derivativeUsage} />
      ) : (
        <div className="body-default">{t('noResultsMessage')}</div>
      )}
    </FundDetailsTabRow>
  );
};

export default FundDetailsDerivativeTab;
